import React from "react";
import Navbar from "../components/navbar.jsx";
import Footer from "../components/footer.jsx";
import EctImg from "../assets/Gallery_Nexus/mentalconditionsback.png";

// Add these files to src/assets/ or replace with hosted URLs

export default function TreatmentApproaches() {
    return (
        <>
            <Navbar />

            <main className="relative min-h-screen pt-24 pb-16 bg-emerald-50">

                {/* =====================================================
                    HERO / TOP BANNER
                ====================================================== */}
                <div className="max-w-7xl mx-auto px-6">

                    <div
                        className="rounded-2xl overflow-hidden bg-gradient-to-r from-emerald-700 to-emerald-600 text-white shadow-2xl p-10 md:p-16 transform-gpu transition-transform hover:-translate-y-1"
                        style={{
                            backgroundImage: EctImg
                                ? `url(${EctImg})`
                                : undefined,
                            backgroundBlendMode: "overlay",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    >

                        <div className="md:flex md:items-center md:justify-between gap-8">

                            <div className="md:flex-1">

                                <h1 className="text-3xl md:text-4xl font-extrabold leading-tight">
                                    Treatment Approaches & Wellness Programs
                                </h1>

                                <p className="mt-4 text-emerald-100 max-w-3xl">
                                    Evidence-based treatments — psychometric assessments,
                                    Deep TMS, ECT and personalised programs delivered by
                                    experienced psychiatrists and clinical teams to support
                                    recovery and wellbeing.
                                </p>

                                <div className="mt-6 flex flex-wrap gap-3">

                                    <a
                                        href="#services"
                                        className="inline-flex items-center gap-2 rounded-full bg-white/90 text-emerald-700 px-5 py-3 font-semibold shadow hover:brightness-95"
                                    >
                                        Explore services
                                    </a>

                                    <a
                                        href="#contact"
                                        className="inline-flex items-center gap-2 rounded-full bg-emerald-900/90 text-white px-5 py-3 font-semibold shadow hover:opacity-95"
                                    >
                                        Enquire now
                                    </a>

                                </div>

                            </div>


                            <div className="mt-8 md:mt-0 md:w-[420px]">

                                <div className="bg-white rounded-xl p-6 shadow-md ring-1 ring-emerald-100">

                                    <h3 className="text-lg font-semibold text-emerald-800">
                                        Quick overview
                                    </h3>

                                    <p className="mt-3 text-sm text-slate-600">
                                        Psychometric testing, neuromodulation (Deep TMS),
                                        ECT, mental health hospitalization support and
                                        personalised treatment programs where clinically
                                        appropriate — with assessment, personalised plans
                                        and continuous monitoring.
                                    </p>

                                    <ul className="mt-4 space-y-2 text-sm text-slate-700">

                                        <li className="flex items-start gap-3">
                                            <span className="mt-1 inline-block h-2.5 w-2.5 rounded-full bg-emerald-600" />
                                            Tailored evaluation & risk assessment
                                        </li>

                                        <li className="flex items-start gap-3">
                                            <span className="mt-1 inline-block h-2.5 w-2.5 rounded-full bg-emerald-600" />
                                            Multidisciplinary team & continuous monitoring
                                        </li>

                                        <li className="flex items-start gap-3">
                                            <span className="mt-1 inline-block h-2.5 w-2.5 rounded-full bg-emerald-600" />
                                            Evidence-based protocols and follow-up
                                        </li>

                                    </ul>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>


                {/* =====================================================
                    PAGE BODY
                ====================================================== */}
                <section className="max-w-7xl mx-auto px-6 mt-10 grid gap-8 lg:grid-cols-[300px_1fr]">

                    {/* =================================================
                        SIDEBAR
                    ================================================== */}
                    <aside className="sticky top-28 self-start hidden lg:block">

                        <div className="rounded-xl bg-white p-5 shadow ring-1 ring-emerald-100">

                            <h4 className="font-semibold text-emerald-800">
                                On this page
                            </h4>

                            <nav className="mt-3 flex flex-col gap-2 text-sm">

                                <a
                                    href="#services"
                                    className="text-slate-700 hover:text-emerald-700"
                                >
                                    Services Overview
                                </a>

                                <a
                                    href="#hospitals"
                                    className="text-slate-700 hover:text-emerald-700"
                                >
                                    Mental Health Hospital 🏥
                                </a>

                                <a
                                    href="#psychometric"
                                    className="text-slate-700 hover:text-emerald-700"
                                >
                                    Psychometric Testing
                                </a>

                                <a
                                    href="#deeptms"
                                    className="text-slate-700 hover:text-emerald-700"
                                >
                                    Deep TMS
                                </a>

                                <a
                                    href="#ect"
                                    className="text-slate-700 hover:text-emerald-700"
                                >
                                    Electroconvulsive Therapy (ECT)
                                </a>

                                <a
                                    href="#faqs"
                                    className="text-slate-700 hover:text-emerald-700"
                                >
                                    FAQs
                                </a>

                                <a
                                    href="#contact"
                                    className="text-slate-700 hover:text-emerald-700"
                                >
                                    Contact / Enquiry
                                </a>

                            </nav>

                        </div>

                    </aside>


                    {/* =================================================
                        MAIN CONTENT
                    ================================================== */}
                    <div className="space-y-8">


                        {/* =================================================
                            SERVICES OVERVIEW
                        ================================================== */}
                        <article
                            id="services"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50"
                        >

                            <h2 className="text-2xl md:text-3xl font-bold text-emerald-800">
                                Mental Health Services & Treatment Approaches
                            </h2>

                            <p className="mt-4 text-slate-700 leading-relaxed">
                                At Nexus Mental Health Foundation, we provide a range of
                                mental health services and treatment approaches designed
                                to support individuals and families through assessment,
                                treatment, recovery and ongoing care.
                            </p>

                            <p className="mt-3 text-slate-700 leading-relaxed">
                                Depending on the individual's needs, care may include
                                psychiatric consultation, psychological assessment,
                                psychotherapy, hospitalisation support, specialised
                                treatments and continuous follow-up.
                            </p>

                            <div className="mt-6 grid gap-4 md:grid-cols-3">

                                <div className="rounded-xl bg-emerald-50 p-5">
                                    <h3 className="font-semibold text-emerald-800">
                                        🧠 Assessment
                                    </h3>

                                    <p className="mt-2 text-sm text-slate-600">
                                        Clinical and psychological assessments help
                                        understand symptoms and individual needs.
                                    </p>
                                </div>

                                <div className="rounded-xl bg-emerald-50 p-5">
                                    <h3 className="font-semibold text-emerald-800">
                                        💬 Therapy
                                    </h3>

                                    <p className="mt-2 text-sm text-slate-600">
                                        Evidence-based counselling and psychotherapy
                                        support emotional and psychological wellbeing.
                                    </p>
                                </div>

                                <div className="rounded-xl bg-emerald-50 p-5">
                                    <h3 className="font-semibold text-emerald-800">
                                        🏥 Specialised Care
                                    </h3>

                                    <p className="mt-2 text-sm text-slate-600">
                                        Hospital support and specialised treatments may
                                        be considered when clinically appropriate.
                                    </p>
                                </div>

                            </div>

                        </article>


                        {/* =================================================
                            NEW SECTION:
                            MENTAL HEALTH HOSPITAL
                        ================================================== */}
                        <article
                            id="hospital"
                            className="rounded-xl bg-white p-6 md:p-8 shadow ring-1 ring-emerald-50 transition hover:shadow-lg"
                        >

                            {/* Section Header */}
                            <div className="flex items-start gap-4">

                                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-emerald-100 text-3xl">
                                    🏥
                                </div>

                                <div>

                                    <h2 className="text-2xl md:text-3xl font-bold text-emerald-800">
                                        Mental Health Hospitalization Support
                                    </h2>

                                    <p className="mt-2 font-medium text-emerald-700">
                                        Safe, immediate and professional inpatient care
                                    </p>

                                </div>

                            </div>


                            {/* Introduction */}
                            <div className="mt-6">

                                <p className="text-slate-700 leading-relaxed">
                                    At Nexus Mental Health Foundation, we understand that
                                    some mental health crises require more than counseling
                                    - they require safe, immediate, and professional
                                    inpatient care.
                                </p>

                                <p className="mt-4 text-slate-700 leading-relaxed">
                                    Mental Health Hospitalization is a structured
                                    treatment process where an individual receives 24/7
                                    medical and psychological support in a hospital
                                    setting for severe anxiety, depression, psychosis,
                                    bipolar episodes, suicidal crisis, or other acute
                                    conditions.
                                </p>

                            </div>


                            {/* Highlight */}
                            <div className="mt-7 rounded-xl bg-emerald-50 border border-emerald-100 p-6">

                                <h3 className="text-xl font-bold text-emerald-800">
                                    When Hospitalization May Be Needed
                                </h3>

                                <p className="mt-3 text-slate-700 leading-relaxed">
                                    Hospital-based care can provide a structured and
                                    closely monitored environment when symptoms become
                                    severe or when an individual requires immediate
                                    psychiatric and psychological support.
                                </p>

                                <div className="mt-5 grid gap-3 sm:grid-cols-2">

                                    <div className="rounded-lg bg-white p-4 text-sm text-slate-700 shadow-sm">
                                        <span className="mr-2 text-emerald-600 font-bold">
                                            ✓
                                        </span>
                                        Severe anxiety or emotional distress
                                    </div>

                                    <div className="rounded-lg bg-white p-4 text-sm text-slate-700 shadow-sm">
                                        <span className="mr-2 text-emerald-600 font-bold">
                                            ✓
                                        </span>
                                        Severe depression
                                    </div>

                                    <div className="rounded-lg bg-white p-4 text-sm text-slate-700 shadow-sm">
                                        <span className="mr-2 text-emerald-600 font-bold">
                                            ✓
                                        </span>
                                        Psychosis
                                    </div>

                                    <div className="rounded-lg bg-white p-4 text-sm text-slate-700 shadow-sm">
                                        <span className="mr-2 text-emerald-600 font-bold">
                                            ✓
                                        </span>
                                        Bipolar episodes
                                    </div>

                                    <div className="rounded-lg bg-white p-4 text-sm text-slate-700 shadow-sm">
                                        <span className="mr-2 text-emerald-600 font-bold">
                                            ✓
                                        </span>
                                        Suicidal crisis
                                    </div>

                                    <div className="rounded-lg bg-white p-4 text-sm text-slate-700 shadow-sm">
                                        <span className="mr-2 text-emerald-600 font-bold">
                                            ✓
                                        </span>
                                        Other acute mental health conditions
                                    </div>

                                </div>

                            </div>


                            {/* How Nexus Supports You */}
                            <div className="mt-8">

                                <h3 className="text-2xl font-bold text-emerald-800">
                                    How Nexus Supports You
                                </h3>

                                <p className="mt-3 text-slate-700 leading-relaxed">
                                    We make this difficult step easier, safer, and more
                                    dignified. We don't just suggest a hospital - we guide
                                    you to the right one.
                                </p>


                                {/* Support Cards */}
                                <div className="mt-6 space-y-4">

                                    {/* 1 */}
                                    <div className="rounded-xl border border-emerald-100 bg-white p-5 shadow-sm">

                                        <div className="flex gap-4">

                                            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-700 text-white font-bold">
                                                1
                                            </div>

                                            <div>

                                                <h4 className="font-bold text-emerald-800">
                                                    Confidential Assessment
                                                </h4>

                                                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                                                    Our team understands your condition,
                                                    location, and budget.
                                                </p>

                                            </div>

                                        </div>

                                    </div>


                                    {/* 2 */}
                                    <div className="rounded-xl border border-emerald-100 bg-white p-5 shadow-sm">

                                        <div className="flex gap-4">

                                            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-700 text-white font-bold">
                                                2
                                            </div>

                                            <div>

                                                <h4 className="font-bold text-emerald-800">
                                                    Verified Hospital Recommendations
                                                </h4>

                                                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                                                    We recommend only trusted, ethical,
                                                    and highly-rated psychiatric hospitals
                                                    and rehabilitation centers from our
                                                    verified network.
                                                </p>

                                            </div>

                                        </div>

                                    </div>


                                    {/* 3 */}
                                    <div className="rounded-xl border border-emerald-100 bg-white p-5 shadow-sm">

                                        <div className="flex gap-4">

                                            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-700 text-white font-bold">
                                                3
                                            </div>

                                            <div>

                                                <h4 className="font-bold text-emerald-800">
                                                    End-to-End Assistance
                                                </h4>

                                                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                                                    From admission formalities and doctor
                                                    connection to family counseling and
                                                    post-discharge care planning.
                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>


                            {/* Hospital Support Process */}
                            <div className="mt-8 rounded-xl bg-slate-50 p-6">

                                <h3 className="text-xl font-bold text-emerald-800">
                                    Our Hospitalization Support Process
                                </h3>

                                <div className="mt-5 grid gap-4 md:grid-cols-4">

                                    <div className="rounded-xl bg-white p-4 shadow-sm">

                                        <div className="text-2xl">
                                            01
                                        </div>

                                        <h4 className="mt-2 font-semibold text-emerald-700">
                                            Understand
                                        </h4>

                                        <p className="mt-2 text-sm text-slate-600">
                                            Understand the individual's condition and
                                            immediate requirements.
                                        </p>

                                    </div>


                                    <div className="rounded-xl bg-white p-4 shadow-sm">

                                        <div className="text-2xl">
                                            02
                                        </div>

                                        <h4 className="mt-2 font-semibold text-emerald-700">
                                            Assess
                                        </h4>

                                        <p className="mt-2 text-sm text-slate-600">
                                            Review location, care requirements and
                                            available options.
                                        </p>

                                    </div>


                                    <div className="rounded-xl bg-white p-4 shadow-sm">

                                        <div className="text-2xl">
                                            03
                                        </div>

                                        <h4 className="mt-2 font-semibold text-emerald-700">
                                            Connect
                                        </h4>

                                        <p className="mt-2 text-sm text-slate-600">
                                            Connect the family with an appropriate
                                            hospital and clinical team.
                                        </p>

                                    </div>


                                    <div className="rounded-xl bg-white p-4 shadow-sm">

                                        <div className="text-2xl">
                                            04
                                        </div>

                                        <h4 className="mt-2 font-semibold text-emerald-700">
                                            Continue
                                        </h4>

                                        <p className="mt-2 text-sm text-slate-600">
                                            Support family counselling and post-discharge
                                            care planning.
                                        </p>

                                    </div>

                                </div>

                            </div>


                            {/* Final Hospital CTA */}
                            <div className="mt-8 rounded-xl bg-gradient-to-r from-emerald-800 to-emerald-600 p-6 md:p-8 text-white">

                                <h3 className="text-2xl font-bold">
                                    You Are Not Alone
                                </h3>

                                <p className="mt-3 max-w-3xl leading-relaxed text-emerald-50">
                                    You are not alone in this. Let Nexus be your bridge
                                    to safe recovery.
                                </p>

                                <div className="mt-5">

                                    <a
                                        href="#contact"
                                        className="inline-flex items-center rounded-full bg-white px-6 py-3 font-semibold text-emerald-800 shadow hover:bg-emerald-50"
                                    >
                                        Get Hospitalization Support
                                    </a>

                                </div>

                            </div>


                            {/* Important note */}
                            <div className="mt-6 rounded-xl border border-amber-200 bg-amber-50 p-5">

                                <p className="text-sm leading-relaxed text-amber-900">
                                    <strong>Important:</strong> Mental health
                                    hospitalization decisions should be made with
                                    appropriate clinical assessment. If someone is in
                                    immediate danger or experiencing an acute psychiatric
                                    emergency, seek urgent medical attention or contact
                                    the nearest hospital.
                                </p>

                            </div>

                        </article>
                        {/* =================================================
    DEVELOPMENT FACILITIES
================================================== */}
                        <article
                            id="development"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50 transition hover:shadow-lg"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Development Facility at Nexus
                            </h2>

                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Nurturing Potential, At Every Stage of Life
                            </h3>

                            <p className="mt-4 text-slate-700">
                                At Nexus Mental Health Foundation, our Development Facility
                                is dedicated to holistic growth, independence, and inclusion.
                                We believe development is a lifelong journey.
                            </p>

                            <p className="mt-3 text-slate-700">
                                Our evidence-based programs are designed separately for
                                children and adults, with individualized care plans, trained
                                professionals, and family involvement at the core.
                            </p>


                            {/* =================================================
        CHILD DEVELOPMENT FACILITY
    ================================================== */}

                            <h3 className="mt-6 text-xl font-bold text-emerald-800">
                                1. Child Development Facility
                            </h3>

                            <h4 className="mt-3 font-semibold text-emerald-700">
                                Early Years, Strong Foundations
                            </h4>

                            <p className="mt-2 text-slate-700">
                                Our Child Development Centre focuses on early identification,
                                intervention, and consistent support for children with
                                developmental needs.
                            </p>


                            <h4 className="mt-5 font-semibold text-emerald-700">
                                Our Services Include:
                            </h4>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-2">

                                <li>
                                    <strong>Early Intervention Program (EIP):</strong>{" "}
                                    For children from 0-6 years with developmental delays,
                                    Autism, ADHD, Down Syndrome and Global Developmental Delay.
                                </li>

                                <li>
                                    <strong>
                                        Occupational Therapy & Sensory Integration:
                                    </strong>{" "}
                                    To improve fine motor skills, gross motor skills,
                                    sensory processing, daily living activities and handwriting.
                                </li>

                                <li>
                                    <strong>Speech & Language Therapy:</strong>{" "}
                                    For delayed speech, articulation, fluency, social
                                    communication and feeding issues.
                                </li>

                                <li>
                                    <strong>
                                        Special Education & Remedial Education:
                                    </strong>{" "}
                                    Individualized Education Plans (IEP) for learning
                                    disabilities, intellectual disabilities and academic
                                    difficulties.
                                </li>

                                <li>
                                    <strong>
                                        Applied Behaviour Analysis (ABA) & Behaviour Modification:
                                    </strong>{" "}
                                    Positive behaviour support for challenging behaviours,
                                    attention and compliance.
                                </li>

                                <li>
                                    <strong>
                                        Play Therapy & Child Counselling:
                                    </strong>{" "}
                                    To build emotional regulation, social interaction,
                                    confidence and peer relationships.
                                </li>

                                <li>
                                    <strong>
                                        Parent Training & Family Counselling:
                                    </strong>{" "}
                                    We empower parents to continue development at home with
                                    regular training and progress reports.
                                </li>

                            </ul>


                            <h4 className="mt-5 font-semibold text-emerald-700">
                                We Support Children With:
                            </h4>

                            <p className="mt-2 text-slate-700">
                                Autism Spectrum Disorder (ASD), ADHD, Speech Delay,
                                Intellectual Disability, Learning Disabilities
                                (Dyslexia, Dysgraphia, Dyscalculia), Cerebral Palsy,
                                Developmental Delays.
                            </p>


                            {/* =================================================
        ADULT DEVELOPMENT FACILITY
    ================================================== */}

                            <h3 className="mt-8 text-xl font-bold text-emerald-800">
                                2. Adult Development Facility
                            </h3>

                            <h4 className="mt-3 font-semibold text-emerald-700">
                                Building Independence, Dignity & Skills
                            </h4>

                            <p className="mt-2 text-slate-700">
                                Our Adult Development Centre focuses on recovery,
                                rehabilitation and reintegration into community and
                                work life.
                            </p>


                            <h4 className="mt-5 font-semibold text-emerald-700">
                                Our Services Include:
                            </h4>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-2">

                                <li>
                                    <strong>
                                        Psychosocial Rehabilitation (PSR):
                                    </strong>{" "}
                                    Structured program to improve daily living, self-care,
                                    money management and community living skills.
                                </li>

                                <li>
                                    <strong>
                                        Vocational Training & Skill Development:
                                    </strong>{" "}
                                    Job-oriented training like computer basics, office
                                    skills, tailoring, art & craft, agriculture and other
                                    work skills based on interest.
                                </li>

                                <li>
                                    <strong>
                                        Independent Living Skills:
                                    </strong>{" "}
                                    Training for cooking, hygiene, travel training,
                                    time management and home management.
                                </li>

                                <li>
                                    <strong>
                                        Adult Counselling & Psychotherapy:
                                    </strong>{" "}
                                    Individual, group and family counselling for anxiety,
                                    depression, stress, OCD, bipolar and other mental
                                    health concerns.
                                </li>

                                <li>
                                    <strong>
                                        Social Skills & Life Skills Development:
                                    </strong>{" "}
                                    Building communication, interpersonal relationships,
                                    emotional regulation and problem-solving.
                                </li>

                                <li>
                                    <strong>
                                        Cognitive Remediation & Brain Wellness:
                                    </strong>{" "}
                                    Activities to improve memory, attention, concentration
                                    and decision-making.
                                </li>

                            </ul>


                            {/* =================================================
        OUR APPROACH
    ================================================== */}

                            <h3 className="mt-8 font-semibold text-emerald-700">
                                Our Approach
                            </h3>

                            <p className="mt-2 text-slate-700">
                                At Nexus, development support is built around the individual's
                                strengths, needs and goals. Our programs combine professional
                                guidance, structured interventions and family involvement to
                                encourage meaningful progress and greater independence.
                            </p>

                            <p className="mt-3 text-slate-700">
                                Whether supporting a child during the early developmental years
                                or helping an adult build greater independence and community
                                participation, our focus is on providing consistent,
                                individualized and compassionate support.
                            </p>

                        </article>
                        {/* =================================================
    CHILDREN THERAPISTS
================================================== */}
                        <article
                            id="children"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50 transition hover:shadow-lg"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Children Therapists
                            </h2>

                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Every Child Deserves to Be Heard, Not Just Seen
                            </h3>

                            <p className="mt-4 text-slate-700">
                                A child therapist is not just an expert - they are a safe
                                space where your child can express what words often can't.
                            </p>

                            <p className="mt-3 text-slate-700">
                                At Nexus, we help children navigate anxiety, anger, learning
                                difficulties, low confidence, and behavioural challenges with
                                care that parents can trust.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Why a Child Therapist is Important?
                            </h3>

                            <p className="mt-1 text-slate-700">
                                Small Struggles Today Can Become Big Hurdles Tomorrow.
                            </p>

                            <p className="mt-3 text-slate-700">
                                Children don't always say "I'm stressed" or "I'm sad". They
                                may show it through tantrums, silence, school avoidance, or
                                aggression.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                Our expert child therapists help to:
                            </h4>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">

                                <li>
                                    Understand the root cause, not just the behaviour
                                </li>

                                <li>
                                    Build emotional strength - confidence, coping, and
                                    communication
                                </li>

                                <li>
                                    Support parents with practical guidance that works at home
                                </li>

                                <li>
                                    Create early intervention that prevents long-term difficulties
                                </li>

                            </ul>


                            <p className="mt-5 text-slate-700 font-medium">
                                Early help is not a label. It's a lifelong gift.
                            </p>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                How Our Experts Work at Nexus
                            </h3>

                            <p className="mt-1 text-slate-700">
                                We Listen. We Play. We Heal.
                            </p>

                            <p className="mt-3 text-slate-700">
                                At Nexus Mental Health Foundation, therapy is not intimidating.
                                It's child-friendly.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                1. Connect
                            </h4>

                            <p className="mt-1 text-slate-700">
                                We build trust through play, art, and conversation.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                2. Assess
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Our experts use child-specific assessments to understand
                                emotional and developmental needs.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                3. Plan
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Every child gets a personalized care plan - no one-size-fits-all.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                4. Partner with Parents
                            </h4>

                            <p className="mt-1 text-slate-700">
                                You are part of the journey. We guide you at every step.
                            </p>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                Our Specialities
                            </h3>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">

                                <li>
                                    Child Counseling
                                </li>

                                <li>
                                    Behaviour Therapy
                                </li>

                                <li>
                                    Play Therapy
                                </li>

                                <li>
                                    Learning & Developmental Support
                                </li>

                                <li>
                                    Parent Counseling
                                </li>

                            </ul>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                Supporting Your Child's Journey
                            </h3>

                            <p className="mt-2 text-slate-700">
                                Every child develops at their own pace and may express
                                emotional or behavioural difficulties differently. With
                                appropriate support, children can develop stronger emotional
                                skills, confidence, communication, and coping strategies.
                            </p>

                            <p className="mt-3 text-slate-700">
                                At Nexus, we work together with children and parents to
                                create a supportive environment where children can feel
                                understood, heard, and encouraged.
                            </p>

                        </article>

                        {/* =================================================
    MENTAL HEALTH HOSPITAL
================================================== */}
                        <article
                            id="hospitals"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50 transition hover:shadow-lg"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Mental Health Hospital 🏥
                            </h2>

                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Mental Health Hospitalization Support
                            </h3>

                            <p className="mt-4 text-slate-700">
                                At Nexus Mental Health Foundation, we understand that some
                                mental health crises require more than counseling - they
                                require safe, immediate, and professional inpatient care.
                            </p>

                            <p className="mt-4 text-slate-700">
                                Mental Health Hospitalization is a structured treatment
                                process where an individual receives 24/7 medical and
                                psychological support in a hospital setting for severe
                                anxiety, depression, psychosis, bipolar episodes, suicidal
                                crisis, or other acute conditions.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                How Nexus Supports You
                            </h3>

                            <p className="mt-1 text-slate-700">
                                We make this difficult step easier, safer, and more
                                dignified. We don't just suggest a hospital - we guide
                                you to the right one.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                1. Confidential Assessment
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Our team understands your condition, location, and budget.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                2. Verified Hospital Recommendations
                            </h4>

                            <p className="mt-1 text-slate-700">
                                We recommend only trusted, ethical, and highly-rated
                                psychiatric hospitals and rehabilitation centers from
                                our verified network.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                3. End-to-End Assistance
                            </h4>

                            <p className="mt-1 text-slate-700">
                                From admission formalities and doctor connection to family
                                counseling and post-discharge care planning.
                            </p>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                You Are Not Alone
                            </h3>

                            <p className="mt-2 text-slate-700">
                                You are not alone in this. Let Nexus be your bridge to
                                safe recovery.
                            </p>

                        </article>

                        {/* =================================================
    ADULT THERAPY
================================================== */}
                        <article
                            id="adulttherapy"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50 transition hover:shadow-lg"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Adult Therapy
                            </h2>

                            <h3 className="mt-4 font-semibold text-emerald-700">
                                A Safe Space to Understand, Heal & Grow
                            </h3>

                            <p className="mt-4 text-slate-700">
                                Life can sometimes feel overwhelming. Stress, anxiety,
                                relationship difficulties, low mood, work pressure and
                                major life changes can affect the way we think, feel and
                                function every day.
                            </p>

                            <p className="mt-3 text-slate-700">
                                At Nexus Mental Health Foundation, our adult therapy services
                                provide a confidential and supportive environment where
                                individuals can talk openly, understand their challenges and
                                develop healthier ways of coping.
                            </p>


                            <h3 className="mt-5 font-semibold text-emerald-700">
                                Why Adult Therapy is Important?
                            </h3>

                            <p className="mt-1 text-slate-700">
                                You don't have to wait until a problem becomes overwhelming
                                before asking for support.
                            </p>

                            <p className="mt-3 text-slate-700">
                                Therapy can help individuals better understand their emotions,
                                identify unhelpful patterns, manage difficult situations and
                                build practical coping strategies for everyday life.
                            </p>


                            <h4 className="mt-5 font-semibold text-emerald-700">
                                Our therapists can help with:
                            </h4>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">

                                <li>
                                    Anxiety, excessive worry and stress
                                </li>

                                <li>
                                    Low mood, emotional difficulties and loss of motivation
                                </li>

                                <li>
                                    Relationship and family difficulties
                                </li>

                                <li>
                                    Work-related stress and burnout
                                </li>

                                <li>
                                    Anger and emotional regulation
                                </li>

                                <li>
                                    Low confidence and self-esteem
                                </li>

                                <li>
                                    Difficult life transitions and adjustment
                                </li>

                                <li>
                                    Coping with grief and loss
                                </li>

                                <li>
                                    Personal growth and improving emotional wellbeing
                                </li>

                            </ul>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                How Our Adult Therapists Work at Nexus
                            </h3>

                            <p className="mt-1 text-slate-700">
                                We Listen. We Understand. We Support.
                            </p>

                            <p className="mt-3 text-slate-700">
                                At Nexus, therapy is built around the individual. Our
                                therapists work collaboratively with you to understand your
                                concerns and develop an approach suited to your needs and
                                goals.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                1. Connect
                            </h4>

                            <p className="mt-1 text-slate-700">
                                We create a confidential and non-judgmental space where you
                                can feel comfortable discussing your thoughts, emotions and
                                experiences.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                2. Understand
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Your therapist works with you to understand your concerns,
                                emotional patterns, triggers and the challenges affecting
                                your everyday life.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                3. Plan
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Together, you develop a personalised therapy plan based on
                                your concerns, strengths, priorities and treatment goals.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                4. Build Skills
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Therapy can help you develop practical skills for managing
                                emotions, coping with stress, improving communication and
                                handling challenging situations.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                5. Review & Progress
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Your progress is reviewed regularly and the therapeutic
                                approach can be adjusted according to your changing needs.
                            </p>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                Our Adult Therapy Approaches
                            </h3>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">

                                <li>
                                    Individual Counselling
                                </li>

                                <li>
                                    Cognitive Behavioural Therapy (CBT)
                                </li>

                                <li>
                                    Supportive Psychotherapy
                                </li>

                                <li>
                                    Stress and Coping Support
                                </li>

                                <li>
                                    Relationship and Family Counselling
                                </li>

                                <li>
                                    Emotional Regulation Support
                                </li>

                                <li>
                                    Life Skills and Personal Development Support
                                </li>

                            </ul>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                You Don't Have to Handle Everything Alone
                            </h3>

                            <p className="mt-2 text-slate-700">
                                Seeking therapy is a step towards understanding yourself
                                better and taking care of your mental wellbeing. With the
                                right professional support, individuals can develop healthier
                                coping strategies and work towards meaningful changes in
                                their lives.
                            </p>

                            <p className="mt-3 text-slate-700">
                                At Nexus Mental Health Foundation, we provide compassionate,
                                confidential and individualised support throughout your
                                therapeutic journey.
                            </p>

                        </article>

                        {/* =================================================
    ADULT PSYCHIATRISTS
================================================== */}
                        <article
                            id="adultpsychiatrists"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50 transition hover:shadow-lg"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Adult Psychiatrists
                            </h2>

                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Professional Psychiatric Care for Adults
                            </h3>

                            <p className="mt-4 text-slate-700">
                                Mental health can affect the way we think, feel, behave,
                                work, and connect with the people around us. Sometimes,
                                professional psychiatric care is needed to understand
                                symptoms and determine the right treatment approach.
                            </p>

                            <p className="mt-3 text-slate-700">
                                At Nexus Mental Health Foundation, our adult psychiatrists
                                provide confidential, compassionate and individualised
                                psychiatric care for adults experiencing emotional,
                                behavioural and mental health concerns.
                            </p>


                            <h3 className="mt-5 font-semibold text-emerald-700">
                                When Should You Consult a Psychiatrist?
                            </h3>

                            <p className="mt-1 text-slate-700">
                                You do not have to wait until symptoms become severe before
                                seeking professional help. A psychiatric evaluation can help
                                understand persistent or troubling changes in mood, thoughts,
                                behaviour or daily functioning.
                            </p>


                            <h4 className="mt-5 font-semibold text-emerald-700">
                                Our psychiatrists can support adults experiencing:
                            </h4>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">

                                <li>
                                    Anxiety, excessive worry and persistent stress
                                </li>

                                <li>
                                    Depression and persistent low mood
                                </li>

                                <li>
                                    Bipolar disorder and significant mood changes
                                </li>

                                <li>
                                    Obsessive-Compulsive Disorder (OCD)
                                </li>

                                <li>
                                    Psychosis and difficulties distinguishing thoughts from reality
                                </li>

                                <li>
                                    Sleep-related difficulties associated with mental health concerns
                                </li>

                                <li>
                                    Emotional and behavioural difficulties
                                </li>

                                <li>
                                    Substance use and de-addiction related concerns
                                </li>

                                <li>
                                    Stress associated with relationships, work or major life changes
                                </li>

                            </ul>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                How Our Psychiatrists Work at Nexus
                            </h3>

                            <p className="mt-1 text-slate-700">
                                We Listen. We Assess. We Treat.
                            </p>

                            <p className="mt-3 text-slate-700">
                                At Nexus Mental Health Foundation, psychiatric care begins
                                with understanding the individual. Our psychiatrists take
                                time to understand your concerns, medical history, symptoms
                                and current circumstances before developing an appropriate
                                treatment plan.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                1. Comprehensive Assessment
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Your psychiatrist discusses your symptoms, concerns, medical
                                history, previous treatment and how your mental health is
                                affecting your everyday life.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                2. Clinical Understanding
                            </h4>

                            <p className="mt-1 text-slate-700">
                                The psychiatrist evaluates the symptoms and considers the
                                factors that may be contributing to your current difficulties.
                                Where appropriate, additional psychological or medical
                                assessments may be recommended.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                3. Personalised Treatment Plan
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Based on the assessment, your psychiatrist develops an
                                individualised treatment plan. Depending on your needs,
                                this may include medication, psychotherapy, lifestyle
                                support or referral to other specialised services.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                4. Regular Follow-up
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Mental health treatment is an ongoing process. Regular
                                consultations allow your psychiatrist to monitor progress,
                                understand changes in symptoms and make appropriate
                                adjustments to the treatment plan.
                            </p>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                Our Psychiatric Services
                            </h3>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">

                                <li>
                                    Adult Psychiatric Consultation
                                </li>

                                <li>
                                    Mental Health Assessment
                                </li>

                                <li>
                                    Medication Management
                                </li>

                                <li>
                                    Mood and Anxiety Disorder Management
                                </li>

                                <li>
                                    OCD and Related Conditions
                                </li>

                                <li>
                                    Psychosis and Severe Mental Health Conditions
                                </li>

                                <li>
                                    Bipolar Disorder Management
                                </li>

                                <li>
                                    De-addiction and Substance Use Support
                                </li>

                                <li>
                                    Coordination with Psychologists and Therapists
                                </li>

                                <li>
                                    Hospitalisation and Advanced Treatment Referral Support
                                </li>

                            </ul>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                Psychiatrist, Therapist or Both?
                            </h3>

                            <p className="mt-2 text-slate-700">
                                Psychiatric care and therapy can complement each other.
                                A psychiatrist primarily evaluates mental health conditions
                                and can provide medical treatment, while a psychologist or
                                therapist provides psychological therapies and counselling.
                                Depending on your needs, a combined approach may provide
                                comprehensive support.
                            </p>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                Confidential & Individualised Care
                            </h3>

                            <p className="mt-2 text-slate-700">
                                Every person's mental health journey is different. At Nexus,
                                we focus on understanding your individual concerns and
                                providing care that respects your needs, preferences and
                                treatment goals.
                            </p>

                            <p className="mt-3 text-slate-700">
                                Seeking psychiatric help is not a sign of weakness. It is a
                                positive step towards understanding your mental health and
                                getting the support you need.
                            </p>

                        </article>
                        {/* =================================================
                            PSYCHOMETRIC TESTING
                        ================================================== */}
                        <article
                            id="psychometric"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Treatment Approaches
                            </h2>

                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Psychometric Test
                            </h3>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                Psychometric Assessments in Clinic
                            </h4>

                            <p className="mt-2 text-slate-700">
                                Understand your mental health needs more clearly with
                                clinically validated psychometric evaluations. These
                                assessments are administered by qualified therapists
                                and psychiatrists at Nexus Centres across Mumbai,
                                Bengaluru, and Delhi, providing deeper insights into
                                your mental well-being.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                Why Psychometric Assessments are important?
                            </h4>

                            <p className="mt-2 text-slate-700">
                                Psychometric assessments provide valuable insights into
                                an individual's mental health, personality traits,
                                cognitive abilities, and emotional well-being. They help
                                mental health professionals identify concerns accurately,
                                support diagnosis, and develop personalized treatment
                                plans. These assessments also enable better understanding,
                                monitoring of progress, and informed decision-making
                                throughout the care journey.
                            </p>


                            <h4 className="mt-4 font-semibold text-emerald-700">
                                Assessments administered by Nexus clinical experts
                            </h4>


                            <h5 className="mt-3 font-semibold text-emerald-700">
                                Intelligence Testing
                            </h5>

                            <p className="mt-1 text-slate-700">
                                Intelligence tests measure different aspects of thinking
                                and learning, such as memory, concentration, and
                                reasoning. They provide insight into a person's
                                intellectual strengths and can support the diagnosis
                                of intellectual disorders.
                            </p>


                            <h5 className="mt-3 font-semibold text-emerald-700">
                                Learning Disability Testing
                            </h5>

                            <p className="mt-1 text-slate-700">
                                Some individuals experience difficulties with specific
                                learning tasks, even when they are highly motivated and
                                intelligent. Assessments can identify conditions like
                                dyslexia, which affects reading, and dyscalculia, which
                                impacts mathematical skills.
                            </p>


                            <h5 className="mt-3 font-semibold text-emerald-700">
                                Personality Testing
                            </h5>

                            <p className="mt-1 text-slate-700">
                                Your personality influences how you think, feel, and
                                behave. Personality tests offer a deeper understanding
                                of these patterns and can help therapists and psychiatrists
                                create more effective treatment plans.
                            </p>


                            <h5 className="mt-3 font-semibold text-emerald-700">
                                Projective Testing
                            </h5>

                            <p className="mt-1 text-slate-700">
                                Projective tests encourage individuals to interpret
                                unclear or abstract images and situations. These
                                responses can help reveal deeper emotions, thoughts,
                                and psychological conflicts. They are commonly used
                                with adults.
                            </p>


                            <h5 className="mt-3 font-semibold text-emerald-700">
                                Neurocognitive Testing
                            </h5>

                            <p className="mt-1 text-slate-700">
                                These assessments examine how effectively the brain
                                performs functions such as attention, language, memory,
                                and reasoning. They can aid in identifying cognitive
                                decline and neurological disorders.
                            </p>


                            <h5 className="mt-4 font-semibold text-emerald-700">
                                OCD Testing
                            </h5>

                            <p className="mt-1 text-slate-700">
                                OCD is marked by persistent unwanted thoughts and
                                repetitive actions. This assessment helps evaluate
                                symptom patterns and determine their severity.
                            </p>


                            <h5 className="mt-4 font-semibold text-emerald-700">
                                ADHD Testing
                            </h5>

                            <p className="mt-1 text-slate-700">
                                ADHD can affect focus, self-control, and activity levels.
                                Through assessment, clinicians can identify the type
                                of ADHD present and understand how significantly it
                                affects daily functioning.
                            </p>


                            <h4 className="mt-6 font-semibold text-emerald-700">
                                FAQ's
                            </h4>


                            <h5 className="mt-3 font-semibold text-emerald-700">
                                1. What are psychometric assessments?
                            </h5>

                            <p className="mt-1 text-slate-700">
                                Psychometric assessments are scientifically designed
                                tools used to measure an individual's cognitive abilities,
                                personality traits, behavioral tendencies, and
                                work-related competencies. Organizations commonly use
                                them to gain objective insights into candidates,
                                helping support informed recruitment, development,
                                and talent management decisions.
                            </p>


                            <h5 className="mt-3 font-semibold text-emerald-700">
                                2. Are psychometric assessments accurate and reliable?
                            </h5>

                            <p className="mt-1 text-slate-700">
                                When developed and validated by qualified professionals,
                                psychometric assessments are highly reliable and
                                consistent. They use standardized methods to minimize
                                bias and provide objective results.
                            </p>


                            <h5 className="mt-3 font-semibold text-emerald-700">
                                3. Can psychometric assessments help identify mental
                                health concerns?
                            </h5>

                            <p className="mt-1 text-slate-700">
                                Psychometric assessments can help identify patterns
                                related to emotional well-being, stress, anxiety,
                                depression, and other psychological concerns. While
                                they are not a substitute for clinical diagnosis,
                                they provide valuable insights that mental health
                                professionals can use.
                            </p>


                            <h5 className="mt-3 font-semibold text-emerald-700">
                                4. How do psychometric assessments support mental health
                                treatment?
                            </h5>

                            <p className="mt-1 text-slate-700">
                                Psychometric assessments help mental health professionals
                                understand an individual's emotional state, personality,
                                coping mechanisms, and behavioural patterns. The results
                                can inform treatment planning, monitor progress over
                                time, and support more personalized interventions.
                            </p>

                        </article>


                        {/* =================================================
                            IMAGE
                        ================================================== */}
                        {EctImg && (
                            <div className="rounded-xl overflow-hidden">

                                <img
                                    src={EctImg}
                                    alt="Mental health treatment"
                                    className="w-full object-cover rounded-xl shadow-md"
                                />

                            </div>
                        )}


                        {/* =================================================
                            DEEP TMS
                        ================================================== */}
                        <article
                            id="deeptms"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50 transition hover:shadow-lg"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Deep Transcranial Magnetic Stimulation (Deep TMS)
                            </h2>

                            <p className="mt-4 text-slate-700">
                                Stability begins when symptoms no longer control your
                                life. Designed for those who have done the hard work
                                and are ready to experience meaningful changes in how
                                their brain responds.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                What is deep TMS?
                            </h3>

                            <p className="mt-1 text-slate-700">
                                Transcranial Magnetic Stimulation (TMS) is a non-invasive
                                treatment that uses targeted magnetic pulses to stimulate
                                specific areas of the brain involved in mood regulation
                                and mental health. It is commonly used for conditions
                                such as depression when traditional treatments have
                                not provided sufficient relief, without requiring
                                surgery or anaesthesia.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Benefits of deep TMS
                            </h3>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">

                                <li>Non-invasive treatment approach</li>
                                <li>No anaesthesia required</li>
                                <li>Minimal side effects</li>
                                <li>Improves mood regulation</li>
                                <li>Supports treatment-resistant depression</li>

                            </ul>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                When deep TMS right for you?
                            </h3>

                            <p className="mt-1 text-slate-700">
                                Although medication and therapy are good tools, there
                                still may be a need for more support like deep TMS.
                                Deep TMS may be a suitable option if you continue to
                                experience symptoms of depression, anxiety, OCD, or
                                other mental health conditions despite therapy or
                                medication. A qualified mental health professional
                                can determine whether this non-invasive treatment
                                aligns with your specific needs and treatment goals.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Step-wise experience of the patient
                            </h3>


                            <h4 className="mt-3 font-semibold text-emerald-700">
                                1. Evaluation
                            </h4>

                            <p className="mt-1 text-slate-700">
                                You will first consult a Nexus psychiatrist to assess
                                whether Deep TMS is appropriate for your condition
                                and to ensure there are no safety risks, such as the
                                presence of metal implants.
                            </p>


                            <h4 className="mt-3 font-semibold text-emerald-700">
                                2. Consent and Preparation
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Your psychiatrist will guide you through the procedure,
                                explain expected outcomes, and outline the treatment
                                schedule, which typically involves weekday sessions
                                over several weeks.
                            </p>


                            <h4 className="mt-3 font-semibold text-emerald-700">
                                3. Treatment
                            </h4>

                            <p className="mt-1 text-slate-700">
                                During the session, you will sit comfortably while
                                wearing a specialized magnetic helmet. The treatment
                                lasts about 20 minutes, and you remain fully awake
                                throughout. No anaesthesia is required.
                            </p>


                            <h4 className="mt-3 font-semibold text-emerald-700">
                                4. Recovery & Follow-up
                            </h4>

                            <p className="mt-1 text-slate-700">
                                After each session, you can immediately return to your
                                regular activities. Your doctor will monitor your
                                progress throughout the course of treatment to assess
                                improvements and outcomes.
                            </p>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                Are you planning for deep TMS? Get start with the evaluation
                            </h3>


                            <h4 className="mt-3 font-semibold text-emerald-700">
                                Why choose deep TMS at Nexus?
                            </h4>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">

                                <li>
                                    It's done fully under psychiatrist's supervision.
                                </li>

                                <li>
                                    Review regularly with individualised treatment
                                    done by certified professionals
                                </li>

                                <li>
                                    Full-support during treatment phase
                                </li>

                            </ul>

                        </article>


                        {/* =================================================
                            ECT IMAGE
                        ================================================== */}
                        {EctImg && (
                            <div className="rounded-xl overflow-hidden">

                                <img
                                    src={EctImg}
                                    alt="ECT illustration"
                                    className="w-full object-cover rounded-xl shadow-md"
                                />

                            </div>
                        )}


                        {/* =================================================
                            ECT
                        ================================================== */}
                        <article
                            id="ect"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Electroconvulsive Therapy (ECT)
                            </h2>

                            <p className="mt-4 text-slate-700">
                                Individuals facing severe, persistent, or
                                treatment-resistant mental health conditions,
                                Electroconvulsive Therapy (ECT) can offer a safe
                                and effective path toward recovery. Designed for
                                those who have not achieved sufficient improvement
                                through medication, psychotherapy, or other
                                interventions, ECT remains one of the most effective
                                treatments available for certain psychiatric conditions.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                What is Electroconvulsive Therapy (ECT)?
                            </h3>

                            <p className="mt-1 text-slate-700">
                                Electroconvulsive Therapy (ECT) is a medically supervised
                                treatment that uses carefully controlled electrical
                                stimulation to induce a brief therapeutic seizure while
                                the patient is under general anaesthesia. The procedure
                                is performed by a trained medical team in a specialized
                                clinical setting, ensuring the highest standards of
                                safety and care.
                            </p>


                            <p className="mt-2 text-slate-700">
                                ECT has been used for decades and is supported by
                                extensive clinical research. It is most commonly
                                recommended for severe depression, treatment-resistant
                                depression, bipolar disorder, severe mania, psychosis,
                                catatonia, and certain psychiatric emergencies where
                                a rapid response is needed. Unlike common misconceptions,
                                modern ECT is a highly regulated procedure that is
                                performed under anaesthesia with continuous monitoring
                                of the patient's health and comfort throughout treatment.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Benefits of ECT
                            </h3>

                            <p className="mt-2 text-slate-700 font-semibold">
                                ECT may offer several benefits for individuals
                                experiencing severe mental health symptoms, including:
                            </p>

                            <ol className="mt-2 list-decimal list-inside text-slate-700 space-y-1">

                                <li>
                                    Highly effective treatment for severe depression
                                    and other psychiatric conditions
                                </li>

                                <li>
                                    Can provide faster symptom relief compared to
                                    some medications
                                </li>

                                <li>
                                    Beneficial for individuals who have not responded
                                    adequately to medication or psychotherapy
                                </li>

                                <li>
                                    Performed under anaesthesia for patient comfort
                                </li>

                                <li>
                                    Closely monitored by a multidisciplinary team
                                    of psychiatrists, anaesthesiologists, and trained
                                    healthcare professionals
                                </li>

                            </ol>


                            <p className="mt-4 text-slate-700">
                                May help improve mood, daily functioning, and overall
                                quality of life.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                When is ECT right for you?
                            </h3>

                            <p className="mt-1 text-slate-700">
                                Medication and psychotherapy remain important components
                                of mental health treatment, but some individuals may
                                require additional interventions to achieve meaningful
                                improvement. ECT may be considered when symptoms are
                                severe, persistent, or significantly affecting quality
                                of life.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                You may be a suitable candidate for ECT if you:
                            </h3>

                            <ol className="mt-2 list-decimal list-inside text-slate-700 space-y-1">

                                <li>
                                    Have severe depression that has not improved with
                                    medication or therapy
                                </li>

                                <li>
                                    Experience recurrent episodes of treatment-resistant
                                    depression
                                </li>

                                <li>
                                    Have bipolar disorder with severe depressive or
                                    manic symptoms
                                </li>

                                <li>
                                    Experience psychotic symptoms associated with
                                    mood disorders
                                </li>

                                <li>
                                    Require rapid symptom relief due to the severity
                                    of your condition
                                </li>

                            </ol>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                A comprehensive psychiatric evaluation is essential
                                to determine whether ECT is appropriate for your
                                individual circumstances.
                            </h3>

                            <p className="mt-2 text-slate-700">
                                Your psychiatrist will review your medical history,
                                current symptoms, previous treatments, and overall
                                health before recommending a treatment plan.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Step-wise experience of the patient
                            </h3>


                            <h4 className="mt-3 font-semibold text-emerald-700">
                                1. Evaluation
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Your journey begins with a detailed consultation with
                                a Nexus psychiatrist. During this assessment, your
                                symptoms, treatment history, medical background, and
                                current health status will be carefully reviewed.
                                Additional medical investigations may be recommended
                                to ensure ECT can be performed safely and effectively.
                            </p>


                            <h4 className="mt-3 font-semibold text-emerald-700">
                                2. Consent and Preparation
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Before treatment begins, your psychiatrist will explain
                                the procedure, expected benefits, potential risks, and
                                treatment schedule. You will have the opportunity to
                                ask questions and provide informed consent. Instructions
                                regarding fasting and medication management prior to
                                treatment will also be provided.
                            </p>


                            <h4 className="mt-3 font-semibold text-emerald-700">
                                3. Treatment
                            </h4>

                            <p className="mt-1 text-slate-700">
                                ECT is administered in a controlled medical environment
                                under general anaesthesia. Once you are comfortably
                                asleep, a carefully measured electrical stimulus is
                                delivered to produce a brief therapeutic seizure.
                                Throughout the procedure, your heart rate, blood
                                pressure, oxygen levels, and overall wellbeing are
                                continuously monitored. The treatment itself lasts
                                only a few minutes, while the overall appointment
                                typically takes one to two hours, including preparation
                                and recovery.
                            </p>


                            <h4 className="mt-3 font-semibold text-emerald-700">
                                4. Recovery & Follow-up
                            </h4>

                            <p className="mt-1 text-slate-700">
                                Following treatment, you will spend time in a recovery
                                area where trained staff will monitor you until you are
                                fully awake and comfortable. Most patients can return
                                home the same day with a companion, following medical
                                advice. Your psychiatrist will regularly review your
                                progress throughout the course of treatment and make
                                adjustments to your care plan as needed to support the
                                best possible outcomes.
                            </p>


                            <h3 className="mt-6 font-semibold text-emerald-700">
                                Are you considering Electroconvulsive Therapy (ECT)?
                            </h3>

                            <p className="mt-2 text-slate-700">
                                Taking the first step begins with a professional
                                evaluation. If you continue to experience severe
                                symptoms despite treatment, ECT may be an option worth
                                exploring. A comprehensive psychiatric assessment can
                                help determine whether this evidence-based treatment
                                aligns with your needs, goals, and recovery journey.
                            </p>


                            <h3 className="mt-4 font-semibold text-emerald-700">
                                Why choose ECT at Nexus?
                            </h3>

                            <ul className="mt-2 list-disc list-inside text-slate-700 space-y-1">

                                <li>
                                    Conducted under the supervision of experienced
                                    psychiatrists
                                </li>

                                <li>
                                    Comprehensive assessment before every treatment plan
                                </li>

                                <li>
                                    Individualized care tailored to each patient's needs
                                </li>

                                <li>
                                    Delivered by trained and certified healthcare
                                    professionals
                                </li>

                                <li>
                                    Continuous medical monitoring throughout treatment
                                </li>

                                <li>
                                    Regular progress reviews and treatment optimization
                                </li>

                                <li>
                                    Compassionate support throughout every stage of
                                    care and recovery
                                </li>

                            </ul>

                        </article>


                        {/* =================================================
                            FAQ
                        ================================================== */}
                        <article
                            id="faqs"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Frequently Asked Questions
                            </h2>


                            <div className="mt-4 space-y-5 text-slate-700">

                                <div>

                                    <h4 className="font-semibold text-emerald-700">
                                        Are psychometric assessments accurate?
                                    </h4>

                                    <p className="mt-1">
                                        When administered and interpreted by qualified
                                        professionals, psychometric assessments are
                                        reliable tools that inform diagnosis and
                                        personalized treatment planning.
                                    </p>

                                </div>


                                <div>

                                    <h4 className="font-semibold text-emerald-700">
                                        Is Deep TMS painful?
                                    </h4>

                                    <p className="mt-1">
                                        Most patients experience mild tapping or scalp
                                        sensations during stimulation. Discomfort is
                                        usually brief and well tolerated.
                                    </p>

                                </div>


                                <div>

                                    <h4 className="font-semibold text-emerald-700">
                                        What is mental health hospitalization?
                                    </h4>

                                    <p className="mt-1">
                                        Mental health hospitalization is a structured
                                        treatment process where an individual receives
                                        continuous medical and psychological support
                                        in a hospital setting when symptoms require
                                        a higher level of care.
                                    </p>

                                </div>


                                <div>

                                    <h4 className="font-semibold text-emerald-700">
                                        Does Nexus help with hospital admission?
                                    </h4>

                                    <p className="mt-1">
                                        Nexus provides guidance and assistance in
                                        identifying appropriate hospital-based care,
                                        including support with admission formalities,
                                        doctor connection, family counselling and
                                        post-discharge care planning.
                                    </p>

                                </div>


                                <div>

                                    <h4 className="font-semibold text-emerald-700">
                                        When should someone consider hospital support?
                                    </h4>

                                    <p className="mt-1">
                                        Hospital-based psychiatric care may be considered
                                        when symptoms are severe, acute or require
                                        continuous professional monitoring. A qualified
                                        mental health professional should assess the
                                        individual's needs.
                                    </p>

                                </div>

                            </div>

                        </article>


                        {/* =================================================
                            CONTACT / ENQUIRY
                        ================================================== */}
                        <article
                            id="contact"
                            className="rounded-xl bg-white p-6 shadow ring-1 ring-emerald-50"
                        >

                            <h2 className="text-2xl font-bold text-emerald-800">
                                Contact & Enquiry
                            </h2>

                            <p className="mt-3 text-slate-700">
                                To learn which program is right for you, schedule an
                                evaluation with our psychiatrists and clinical specialists.
                            </p>


                            <div className="mt-6 grid gap-4 md:grid-cols-3">

                                <div className="rounded-xl bg-emerald-50 p-5">

                                    <h3 className="font-semibold text-emerald-800">
                                        Clinical Assessment
                                    </h3>

                                    <p className="mt-2 text-sm text-slate-600">
                                        Begin with an appropriate professional
                                        assessment of your needs.
                                    </p>

                                </div>


                                <div className="rounded-xl bg-emerald-50 p-5">

                                    <h3 className="font-semibold text-emerald-800">
                                        Hospital Support
                                    </h3>

                                    <p className="mt-2 text-sm text-slate-600">
                                        Get guidance regarding appropriate psychiatric
                                        hospital and inpatient care.
                                    </p>

                                </div>


                                <div className="rounded-xl bg-emerald-50 p-5">

                                    <h3 className="font-semibold text-emerald-800">
                                        Treatment Planning
                                    </h3>

                                    <p className="mt-2 text-sm text-slate-600">
                                        Explore appropriate treatment and follow-up
                                        options with clinical professionals.
                                    </p>

                                </div>

                            </div>


                            <div className="mt-6">

                                <a
                                    href="#enquire"
                                    className="inline-flex items-center rounded-full bg-emerald-700 px-5 py-3 text-white font-semibold shadow hover:bg-emerald-800"
                                >
                                    Enquire / Book evaluation
                                </a>

                            </div>

                        </article>


                    </div>

                </section>

            </main>

            <Footer />

        </>
    );
}